<!--自定义icon-->
<template>
  <svg class="svg-icon" aria-hidden="true" :style="{ width: size, height: size, margin: margin }">
    <use :xlink:href="iconName"></use>
  </svg>
</template>

<script>
export default {
  name: 'IconSvg',
  props: {
    iconClass: {
      type: String,
      required: true
    },
    size: {
      type: String
    },
    margin: {
      type: String
    }
  },
  computed: {
    iconName () {
      return `#el-icon-bm-${this.iconClass}`
    }
  }
}
</script>

<style scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  fill: currentColor;
  overflow: hidden;
}
</style>
